module.exports = "<label>\r\n  <ng-content></ng-content>\r\n  <input type=\"file\"\r\n  class=\"ng4-files-upload-btn\"\r\n  [multiple]=\"maxFilesCount > 1\"\r\n  #spyNg4FilesInputSpy\r\n  accept=\"{{acceptExtensions}}\"\r\n  (change)=\"onChange(spyNg4FilesInputSpy.files); spyNg4FilesInputSpy.value=''\" />\r\n</label>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shelf/Clouddata/ng4-files/components/ng4-files-click/ng4-files-click.component.html
// module id = ./src/app/shelf/Clouddata/ng4-files/components/ng4-files-click/ng4-files-click.component.html
// module chunks = main